import { render, staticRenderFns } from "./requests-update-history.vue?vue&type=template&id=b2146f36&"
import script from "./requests-update-history.vue?vue&type=script&lang=js&"
export * from "./requests-update-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports